import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./Pages/Landing/landing.jsx";
import Home from "./Pages/Home/home.jsx";
import { AudioProvider } from "./Context/AudioContext.js";

export default function App() {
  return (
    <Router>
      <AudioProvider>
      <Routes>
        
        <Route path="/" element={<Landing />} />
          <Route path="/home/s" element={<Home tipo="s" />} />
          <Route path="/home/c" element={<Home tipo="c" />} />
      </Routes>
      </AudioProvider>
    </Router>
  );
}


